import { render, staticRenderFns } from "./LgsArticles.vue?vue&type=template&id=4ecce0e1&"
import script from "./LgsArticles.vue?vue&type=script&lang=js&"
export * from "./LgsArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports